/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Status_FinishedInputs */



/**
* | output |
* | --- |
* | "Finished" |
*
* @param {Tournament_Status_FinishedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_status_finished = /** @type {((inputs?: Tournament_Status_FinishedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Status_FinishedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalizado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finalizado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Concluso")
	return /** @type {LocalizedString} */ ("Finished")
});